<app-dialog
  class="error-details-dialog"
  headerGlyph="cancel"
  headerText="Move Failed"
  saveText="Retry"
  cancelText="Close"
  [showTopCancelButton]="false"
  [body]="body"
  (save)="onRetry()"
  [additionalFooterButtons]="copyBtn"
  (cancel)="onClose()"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div class="general-error-msg">{{ generalErrorMsg }}</div>
        @if (viewDetailsTextVisible) {
          <span
            href="#"
            class="view-error-details link-color"
            (click)="viewErrorDetails()"
            >View details</span
          >
        }
        @if (showMoreDetails) {
          <span>{{ errorMsgMoreDetails }}</span>
        }
      </div>
    }
  </ng-template>
  <ng-template #copyBtn>
    <fd-button-bar
      label="Copy Details"
      fdType="transparent"
      [fdCompact]="true"
      (click)="onCopy()"
      id="dialog-copy-btn"
      class="uppercase-btn"
      ariaLabel="OK Transparent"
    >
    </fd-button-bar>
  </ng-template>
</app-dialog>
